import styled from '@emotion/styled';
import { Button as BsButton } from 'react-bootstrap';

export const StyledButton = styled(BsButton)`
    min-width: 120px;
`;
